<template>
  <div>
    <div class="cui__utils__heading">
      <strong>Zaposleni: Pregled</strong>
    </div>
    <div class="card">
      <div class="card-header card-header-flex">
        <div class="d-flex flex-column justify-content-center mr-auto">
          <h5 class="mb-0">Svi zaposleni</h5>
        </div>
        <div class="d-flex flex-column justify-content-center">
          <router-link to="/apps/onboarding"><a class="btn btn-primary" href="javascript: void(0);">Registracija novog zaposlenja</a></router-link>
        </div>
      </div>
      <div class="card-body">
        <a-table :columns="columns" :dataSource="data">
          <div
            slot="filterDropdown"
            slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
            class="custom-filter-dropdown"
          >
            <a-input
              v-ant-ref="c => searchInput = c"
              :placeholder="`Search ${column.dataIndex}`"
              :value="selectedKeys[0]"
              @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
              @pressEnter="() => handleSearch(selectedKeys, confirm)"
              style="width: 188px; margin-bottom: 8px; display: block;"
            />
            <a-button
              type="primary"
              @click="() => handleSearch(selectedKeys, confirm)"
              size="small"
              style="width: 90px; margin-right: 8px"
            >Search</a-button>
            <a-button
              @click="() => handleReset(clearFilters)"
              size="small"
              style="width: 90px"
            >Reset</a-button>
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <template slot="image" slot-scope="text, record">
            <img :src="record.img" :style="{
              width: '36px',
              height: 'auto',
              'border-radius': '50%'
              }"
            />
          </template>
          <template slot="name" slot-scope="text, record">
              <h6>{{record.name}}</h6>
              <span>{{record.email}}</span>
          </template>
          <template slot="progress" slot-scope="bar">
            <div class="progress">
              <div
                :class="['progress-bar', bar.color]"
                :style="{width: bar.value + '%'}"
                role="progressbar"
              ></div>
            </div>
          </template>
          <template slot="role" slot-scope="text, record">
            <span class="font-weight-bold">{{text}}</span><br>
            <span class="font-weight-light">{{record.department}}</span>
          </template>
          <a
            slot="id"
            slot-scope="text"
            href="javascript: void(0);"
            class="btn btn-sm btn-light"
          >{{text}}</a>
          <span slot="total" slot-scope="text">${{text}}</span>
          <span slot="tax" slot-scope="text">${{text}}</span>
          <span slot="reportingto" slot-scope="text">{{text}}</span>
          <span
            slot="status"
            slot-scope="text"
            :class="getClassForStatus(text)"
          >{{text}}</span>
          <span slot="action">
            <a href="javascript: void(0);" class="btn btn-sm btn-light mr-2">
              <i class="fe fe-edit mr-2" />
              Pregled
            </a>
          </span>
        </a-table>
      </div>
    </div>
  </div>
</template>
<script>
import data from './data.json'
const columns = [
  {
    title: '',
    dataIndex: 'img',
    key: 'img',
    scopedSlots: {
      customRender: 'image',
    },
  },

  {
    title: 'ID',
    dataIndex: 'id',
    scopedSlots: { customRender: 'id' },
    sorter: (a, b) => a.id - b.id,
  },
  {
    title: 'Ime',
    dataIndex: 'name',
    key: 'tags',
    scopedSlots: {
      customRender: 'name',
    },
  },
  {
    title: 'Kontakt telefon',
    dataIndex: 'phone',
  },
  {
    title: 'Datum zaposlenja',
    dataIndex: 'date',
  },
  {
    title: 'Godine staža',
    dataIndex: 'years',
    sorter: (a, b) => a.years - b.years,
  },
  {
    title: 'Pozicija',
    dataIndex: 'role',
    scopedSlots: { customRender: 'role' },
  },
  {
    title: 'Nadjređeni',
    dataIndex: 'reportingto',
    scopedSlots: { customRender: 'reportingto' },
  },
  {
    title: 'Quantity',
    dataIndex: 'quantity',
    sorter: (a, b) => a.quantity - b.quantity,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    sorter: (a, b) => a.status.length - b.status.length,
    scopedSlots: { customRender: 'status' },
  },
  {
    title: 'Action',
    scopedSlots: { customRender: 'action' },
  },
]
export default {
  data: function () {
    return {
      searchText: '',
      searchInput: null,
      data,
      columns,
    }
  },
  methods: {
    getClassForStatus (status) {
      var baseClass = 'font-size-12 badge badge-'
      switch (status) {
        case 'active':
          baseClass += 'success'
          break
        case 'vacating':
          baseClass += 'warning'
          break
        case 'termination':
          baseClass += 'danger'
          break
        case 'onboarding':
          baseClass += 'primary'
          break

        default:
          break
      }

      return baseClass
    },
    handleSearch(selectedKeys, confirm) {
      confirm()
      this.searchText = selectedKeys[0]
    },

    handleReset(clearFilters) {
      clearFilters()
      this.searchText = ''
    },
  },
}
</script>
<style scoped>
.custom-filter-dropdown {
  padding: 8px;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
